import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhFormComponent } from './components/fh-form.component';
import { InputTextModule } from 'primeng/inputtext';
import { ReactiveFormsModule } from '@angular/forms';
import { FhFormValidators } from './helpers/object/fh-form-validators';
import { FhButtonModule } from '@fh-client-interaction-frontends/fh-button';
import { FhInputConfigPipe } from './helpers/pipes/fh-input-config/fh-input-config.pipe';
import { FhRequiredNotesModule } from '@fh-client-interaction-frontends/fh-required-notes';

@NgModule({
  imports: [CommonModule, InputTextModule, ReactiveFormsModule, FhButtonModule, FhRequiredNotesModule],
  declarations: [FhFormComponent, FhInputConfigPipe],
  exports: [FhFormComponent, FhInputConfigPipe],
  providers: [FhFormValidators]
})
export class FhFormModule {}
